<template>
  <div>
    <input class="form-control" v-model="time" :disabled="disabled"/>
    <div class="text-danger" v-if="!showFormatError">Invalid time format (HH:MM)</div>
  </div>
</template>

<script>
  export default {
    props: ['default', 'disabled'],
    data() {
      return {
        time: null,
      }
    },
    created() {
      if (this.default) {
        this.time = this.default
      }
    },

    watch: {
      time(value) {
        if (this.isValid(value)) {
          this.$emit('durationPicked', value)
        } else {
          this.$emit('durationPicked', false)
        }
      },
    },
    computed: {
      showFormatError() {
        return this.isValid(this.time)
      }
    },

    methods: {
      isValid(value) {
        let values = value.split(':');
        return values.length === 2 && (parseInt(values[1]) >= 0 && parseInt(values[1]) <= 60);
      }
    },


  }
</script>



// WEBPACK FOOTER //
// src/components/partials/DurationPicker.vue